import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { IID_EP_SUPPORT_GISFO } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IIDepGisfoSupportState extends EntityState<IID_EP_SUPPORT_GISFO, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_EP_GISFO_SUPPORT })
export class IIDepGisfoSupportStore extends EntityStore<IIDepGisfoSupportState> {
  constructor() {
    super([]);
  }
}
